import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { Observable, from } from 'rxjs';
import { PagedData, PagedDataUserMenu } from 'src/app/shared/models/paged-data';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { menuPageParams, PageParams } from 'src/app/shared/common/Enums';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionService {


  constructor(
    private webApiService: WebApiService,

    ) { }

    acceptTermsAndConditions(params:any): Promise<any> {
        let apiUrl = `/users/acceptTermsAndConditions`;
        return this.webApiService.postRequest<any>(apiUrl, params)

    }
}